/* @flow */

import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (min-width: 768px) {
    max-width: 750px;
  }
  @media (min-width: 992px) {
    max-width: 970px;
  }
  @media (min-width: 1260px) {
    max-width: ${({ theme }) => theme.maxWidth};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction = 'row' }) => direction};
  flex: 1;
  padding-bottom: 200px;
  .tab-content {
    margin-top: 20px;
  }
`;

export const SubTitle = styled.h1`
  padding-top: 45px;
  padding-bottom: ${({ bottom = 20 }) => `${bottom}px`};
  margin-bottom: 0;
  line-height: 43px;
  font-size: 34px;
  font-weight: 600;
  color: #212833 !important;
  font-family: ${({ theme }) => theme.fontIBMSemiBold};
`;

export default Container;
